import date from './date';
import { ctDate } from './date';
import dateAndTime from './dateTime';

const formatters = {
	datetime: {
		date,
		ctDate,
		dateAndTime,
	}
};

export default formatters;
